export const isSelection = (): boolean => {
  const selection = window.getSelection();
  return selection && selection.toString().length > 0;
};
